module.exports = "/_next/static/resources/ingredients-05e78c1a2333d09601021592688e81a4.webp";